export const LETS_MEAL_API_URL = process.env.NEXT_PUBLIC_FAST_LANE_API_URL;
